import * as z from "zod";
import { requiredString } from "components/form/utils";

export const clientContextSchema = z.object({
    nda_level: requiredString(),
    industry: requiredString(),
    sub_industry: requiredString(),
    client_requirement: requiredString(),
});
